import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

// Components - imported
import { Button } from '@material-ui/core';

// Icons
import LockIcon from '@material-ui/icons/Lock';
import WatchLaterIcon from '@material-ui/icons/WatchLater';
import RoomIcon from '@material-ui/icons/Room';
import CakeIcon from '@material-ui/icons/Cake';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import VisibilityIcon from '@material-ui/icons/Visibility';
import SchoolIcon from '@material-ui/icons/School';
import PublicIcon from '@material-ui/icons/Public';
import { format } from 'date-fns';

// Displays if the user is logged in AND has set up profile
const AboutSection = ({ 
    group: {
        group,
        loading
    }
}) => {

    const hasSocialLinks = (group?.socials?.instagram || group?.socials?.twitter || group?.socials?.facebook || group?.socials?.youtube || group?.socials?.tiktok);

    // Render the component
    return (
        <div style={{padding: '16px', borderBottom: '1px solid #e6ecf0', width: '100%'}}>
            <div style={{color:'rgb(15, 20, 25)', marginBottom: '1rem', fontWeight:'700', fontSize:'24px', lineHeight:'24px', overflowWrap:'break-word'}}>
                <span style={{fontSize: '1.125rem'}}>About this Group</span>
            </div>
            
            {group?.description && (
                <div style={{display: 'flex', alignItems: 'center', width: '100%', marginBottom: '1rem'}}>
                    <div style={{display: 'flex', flexDirection: 'column'}}>
                        <h5 style={{fontWeight: 500, fontSize: '1rem', color: 'rgb(83, 100, 113)'}}>
                            {group.description}
                        </h5>
                    </div>
                </div>
            )}

            {hasSocialLinks && (
                <div style={{display: 'flex', alignItems: 'center', width: '100%', paddingBottom: '1rem', marginBottom: '1rem', borderBottom: '1px solid #e6ecf0'}}>
                    <div style={{display: 'flex', flexDirection: 'column'}}>
                        <h5 style={{fontWeight: 500, fontSize: '1rem', color: 'rgb(83, 100, 113)'}}>
                            Follow us on:
                        </h5>
                        <ul>
                            {group?.socials?.instagram && (
                                <li style={{marginTop: '5px'}}>
                                    <a href={group.socials?.instagram} target="_blank" style={{textDecoration: 'none'}}>Instagram</a>
                                </li>
                            )}
                            {group?.socials?.twitter && (
                                <li style={{marginTop: '5px'}}>
                                    <a href={group.socials?.twitter} target="_blank" style={{textDecoration: 'none'}}>Twitter</a>
                                </li>
                            )}
                            {group?.socials?.facebook && (
                                <li style={{marginTop: '5px'}}>
                                    <a href={group.socials?.facebook} target="_blank" style={{textDecoration: 'none'}}>Facebook</a>
                                </li>
                            )}
                            {group?.socials?.youtube && (
                                <li style={{marginTop: '5px'}}>
                                    <a href={group.socials?.youtube} target="_blank" style={{textDecoration: 'none'}}>Youtube</a>
                                </li>
                            )}
                            {group?.socials?.tiktok && (
                                <li style={{marginTop: '5px'}}>
                                    <a href={group.socials?.tiktok} target="_blank" style={{textDecoration: 'none'}}>Tiktok</a>
                                </li>
                            )}
                        </ul>
                    </div>
                </div>
            )}

            {/* Privacy section */}
            <div style={{display: 'flex', alignItems: 'center', width: '100%', marginBottom: '1rem'}}>
                {group?.privacy === 'public' && (
                    <Fragment>
                        <PublicIcon/>
                        <div style={{paddingLeft: '1rem', display: 'flex', flexDirection: 'column'}}>
                            <h5 style={{fontWeight: 500, fontSize: '1rem', marginBottom: '0.25rem'}}>
                                Public
                            </h5>
                            <h5 style={{fontWeight: 500, fontSize: '1rem', color: 'rgb(83, 100, 113)'}}>
                                Anyone can view and post.
                            </h5>
                        </div>
                    </Fragment>
                )}
                {group?.privacy === 'restricted' && (
                    <Fragment>
                        <VisibilityIcon/>
                        <div style={{paddingLeft: '1rem', display: 'flex', flexDirection: 'column'}}>
                            <h5 style={{fontWeight: 500, fontSize: '1rem', marginBottom: '0.25rem'}}>
                                Restricted
                            </h5>
                            <h5 style={{fontWeight: 500, fontSize: '1rem', color: 'rgb(83, 100, 113)'}}>
                                Anyone can view, but only members can post.
                            </h5>
                        </div>
                    </Fragment>
                )}
                {group?.privacy === 'private' && (
                    <Fragment>
                        <LockIcon/>
                        <div style={{paddingLeft: '1rem', display: 'flex', flexDirection: 'column'}}>
                            <h5 style={{fontWeight: 500, fontSize: '1rem', marginBottom: '0.25rem'}}>
                                Private
                            </h5>
                            <h5 style={{fontWeight: 500, fontSize: '1rem', color: 'rgb(83, 100, 113)'}}>
                                Only members can view and post.
                            </h5>
                        </div>
                    </Fragment>
                )}
                {group?.privacy === 'students only' && (
                    <Fragment>
                        <SchoolIcon/>
                        <div style={{paddingLeft: '1rem', display: 'flex', flexDirection: 'column'}}>
                            <h5 style={{fontWeight: 500, fontSize: '1rem', marginBottom: '0.25rem'}}>
                                Students only
                            </h5>
                            <h5 style={{fontWeight: 500, fontSize: '1rem', color: 'rgb(83, 100, 113)'}}>
                                Only verified students can view and post.
                            </h5>
                        </div>
                    </Fragment>
                )}
            </div>
            {group?.date && (
                <div style={{display: 'flex', alignItems: 'center', width: '100%', marginBottom: '1rem'}}>
                    <CakeIcon />
                    <div style={{paddingLeft: '1rem', display: 'flex', flexDirection: 'column'}}>
                        <h5 style={{fontWeight: 500, fontSize: '1rem', marginBottom: '0.25rem'}}>
                            Created
                        </h5>
                        <h5 style={{fontWeight: 500, fontSize: '1rem', color: 'rgb(83, 100, 113)'}}>
                            {format(group.date, "MMMM dd, yyyy")}
                        </h5>
                    </div>
                </div>
            )}
            {(group?.location_details?.city && group.location_details?.state) && (
                <div style={{display: 'flex', alignItems: 'center', width: '100%', marginBottom: '1rem'}}>
                    <RoomIcon />
                    <div style={{paddingLeft: '1rem', display: 'flex', flexDirection: 'column'}}>
                        <h5 style={{fontWeight: 500, fontSize: '1rem', marginBottom: '0.25rem'}}>
                            Location
                        </h5>
                        <h5 style={{fontWeight: 500, fontSize: '1rem', color: 'rgb(83, 100, 113)'}}>
                            {group.location_details?.city}, {group.location_details?.state && group.location_details?.state}
                        </h5>
                    </div>
                </div>
            )}
        </div>
    )
}

// Prop types for the component
AboutSection.propTypes = {

    // Prop type validation for function to toggle the Authentication modal
    nav: PropTypes.object.isRequired,
    group: PropTypes.object.isRequired,
}

const mapStateToProps = state => ({
    nav: state.nav,
    group: state.group
})

export default connect(mapStateToProps, { 

    // Connecting actions from Redux to the component
})(AboutSection);
